module.exports = __webpack_public_path__ + "static/img/risechart.0dfdc61a.png";